<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->

      <!-- Filter -->
      <v-card class="d-print-none mb-4">
        <v-container class="py-0 px-1">
          <v-form ref="form">
            <div class="d-flex overline justify-start align-center px-3">
              <!-- <v-divider class="mr-4"></v-divider> -->
              <v-icon class="grey--text" x-small>mdi-filter</v-icon>
              <div class="pl-2 grey--text" style="font-size: 10px">
                {{ $t("filters") }}
              </div>
              <v-divider class="ml-4"></v-divider>
            </div>

            <v-row class="d-print-none px-2">
              <v-col cols="12" md="12" sm="12">
                <!-- toggle STATUS (ONLY DESKTOP) -->
                <v-btn-toggle
                  v-model="toggle_none"
                  style="width: 100%"
                  class="hidden-xs-only"
                >
                  <v-btn
                    large
                    v-for="(item, index) in status"
                    :key="index"
                    style="flex: 1"
                    @click="filter.active = item.value"
                  >
                    <v-icon left :color="item.color" size="10"
                      >mdi-circle</v-icon
                    >
                    {{ item.text }}
                  </v-btn>
                </v-btn-toggle>

                <!-- Select STATUS (ONLY MOBILE) -->
                <v-autocomplete
                  :items="status"
                  label="Selecione um status"
                  item-text="text"
                  item-value="value"
                  @change="setStatusMobile"
                  dense
                  filled
                  hide-details
                  solo-inverted
                  clearable
                  class="hidden-sm-and-up"
                >
                  <template v-slot:item="data">
                    <v-icon left :color="data.item.color" size="10"
                      >mdi-circle</v-icon
                    >
                    {{ data.item.text }}
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="12" sm="12" class="py-0">
                <transition name="fade">
                  <v-form v-on:submit="doFilter" onSubmit="return false;">
                    <v-autocomplete
                      v-model="filter.id_category"
                      :items="countries"
                      :label="$t('selectCountry')"
                      item-text="category_name"
                      item-value="category_id"
                      dense
                      filled
                      hide-details
                      solo-inverted
                      clearable
                      v-show="filter.active == 1"
                    >
                      <template v-slot:item="data">
                        <img
                          width="15"
                          class="mr-4"
                          :src="
                            `https://sga-assets.s3-sa-east-1.amazonaws.com/flags/1x1/${data.item.flag}.svg`
                          "
                        />
                        {{ data.item.category_name }}
                      </template>
                    </v-autocomplete>
                  </v-form>
                </transition>
              </v-col>
            </v-row>
            <!-- end Filtro por pais -->

            <v-card-actions class="pb-3">
              <v-divider class="mr-4"></v-divider>
              <v-btn class="info" small @click="doFilter" :disabled="blocked">
                <v-icon small left>mdi-filter</v-icon>
                {{ $t("toFilter") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-container>
      </v-card>
      <!-- Filter -->

      <!-- Datatable -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <!-- Button Imprimir -->
            <v-col cols="6" md="9">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <!-- End Button Imprimir -->

            <v-col
              cols="6"
              class="d-flex flex-row-reverse d-md-none d-lg-none d-xl-none"
            >
              <div>
                <v-btn-toggle dense>
                  <v-btn @click="breackPoint = 0" ref="desktopBreakpoint">
                    <v-icon>mdi-view-list</v-icon>
                  </v-btn>

                  <v-btn @click="breackPoint = 'xs'" ref="mobileBreakpoint">
                    <v-icon>mdi-view-grid</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>

            <!-- Search Table -->
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
            <!-- End Search Table -->
          </v-row>
        </div>
        <v-divider></v-divider>

        <!-- Table -->
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          :items-per-page="10"
          :mobile-breakpoint="breackPoint"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
          ref="dataTable"
          @update:page="$vuetify.goTo($refs.dataTable)"
        >
          <template v-slot:item.id_event="{ item }">
            <v-btn @click="$copy(item.id_event)" x-small>
              {{ item.id_event }}
            </v-btn>
          </template>

          <!-- Status -->
          <template v-slot:item.active="{ item }">
            <v-chip :color="item.active.color" outlined small>{{
              item.active.text
            }}</v-chip>
          </template>
          <!-- Status -->

          <!--  -->
          <template v-slot:item.action="{ item }">
            <v-btn-toggle dense>
              <v-tooltip left v-if="canSuspendEventAndActivateEvent">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    :title="$t('suspendEvent')"
                    @click="activeSuspendEvent(item, 0)"
                    v-show="tabStatus == 1"
                  >
                    <v-icon size="24">mdi-minus-circle-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("suspendEvent") }}</span>
              </v-tooltip>

              <v-tooltip left v-if="canCancelEventAndPostponeEvent">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    :title="$t('cancelEvent')"
                    @click="cancel(item)"
                    v-show="tabStatus == 2"
                    :loading="loading"
                    :disabled="loading"
                  >
                    <v-icon size="24">mdi-cancel</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("cancelEvent") }}</span>
              </v-tooltip>

              <v-tooltip left v-if="canCancelEventAndPostponeEvent">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    :title="$t('postponeEvent')"
                    @click="cancel(item)"
                    v-show="tabStatus == 3"
                    :loading="loading"
                    :disabled="loading"
                  >
                    <v-icon size="24">mdi-clock</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("postponeEvent") }}</span>
              </v-tooltip>

              <v-tooltip left v-if="canSuspendEventAndActivateEvent">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    :title="$t('activateEvent')"
                    @click="activeSuspendEvent(item, 1)"
                    v-show="tabStatus == 4"
                  >
                    <v-icon size="24">mdi-check-circle-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("activateEvent") }}</span>
              </v-tooltip>

              <v-tooltip left v-if="canEditOdds">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    :title="$t('editOdds')"
                    v-show="tabStatus == 1 || tabStatus == 4"
                    @click="
                      [
                        $router
                          .push({
                            name: 'CollaboratorEventEditOdds',
                            params: { id: item.id_event },
                            query: {
                              event: item.description,
                              date: item.scheduled,
                              tournament: item.tournament_name,
                              status: item.active.status,
                              id_sport: item.id_sport
                            },
                          })
                          .catch(() => {}),
                        showDialog('EditOdds'),
                      ]
                    "
                  >
                    <v-icon size="24">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("editOdds") }}</span>
              </v-tooltip>

              <v-tooltip left v-if="canBetPlacedReport">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    :title="$t('betPlacedReport')"
                    v-show="tabStatus == 1"
                    @click="
                      [
                        $router
                          .push({
                            name: 'CollaboratorBetPlacedReport',
                            params: { id: item.id_event },
                            query: {
                              event: item.description,
                              date: item.scheduled,
                              tournament: item.tournament_name,
                            },
                          })
                          .catch(() => {}),
                        showDialog('BetPlacedReport'),
                      ]
                    "
                  >
                    <v-icon size="24">mdi-database-search</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("betPlacedReport") }}</span>
              </v-tooltip>

              <v-tooltip left v-if="canAllMarketsReport">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    :title="$t('allMarketsReport')"
                    v-show="tabStatus == 1"
                    @click="
                      [
                        $router
                          .push({
                            name: 'CollaboratorMarketReportByEvent',
                            params: { id: item.id_event },
                            query: {
                              event: item.description,
                              date: item.scheduled,
                              tournament: item.tournament_name,
                              active: item.active,
                              id: item.id_event,
                            },
                          })
                          .catch(() => {}),
                        showDialog('AllMarketsReport'),
                      ]
                    "
                  >
                    <v-icon size="24">mdi-chart-box</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("allMarketsReport") }}</span>
              </v-tooltip>

              <v-tooltip left v-if="canListMainEvents">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    :disabled="
                      item.id_sport == 10 ||
                        item.id_sport == 51 ||
                        (!isMainEvent(item) && !canAddMainEvent) ||
                        (isMainEvent(item) && !canRemoveMainEvent)
                    "
                    small
                    :title="getAddOrRemoveMainEventText(isMainEvent(item))"
                    v-show="tabStatus == 1"
                    @click="addOrRemoveMainEvent(item, isMainEvent(item))"
                  >
                    <v-icon size="24">
                      {{
                        isMainEvent(item) ? "mdi-heart" : "mdi-heart-outline"
                      }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ getAddOrRemoveMainEventText(isMainEvent(item)) }}
                </span>
              </v-tooltip>
            </v-btn-toggle>
          </template>
        </v-data-table>
        <!-- End Table -->
      </v-card>
      <!-- End Datatable -->
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "collaborator-events-list",
  components: {
    HeaderPrint,
  },
  data: () => ({
    search: "",
    data: [],
    breackPoint: 0,
    toggle_none: null,
    countries: [],
    status: [],
    blocked: true,
    filter: {
      active: "",
      id_category: "",
    },
    tabStatus: "",
    colors: {
      1: "green",
      2: "purple",
      3: "orange",
      4: "red",
    },
    colorsColumns: {
      // Ativos
      1: "green darken-4",
      2: "green accent-4",
      9: "green darken-1",
      // Cancelados
      4: "red darken-1",
      7: "red lighten-2",
      // Adiados
      5: "purple darken-1",
      // Suspensos
      3: "amber accent-4",
      6: "amber darken-1",
    },
    loading: false,

    mainEvents: [],
    mainEventLoading: false,
  }),

  computed: {
    headers() {
      const hideActionsTab1 =
        this.tabStatus == 1 &&
        !this.$permission("78") &&
        !this.$permission("79") &&
        !this.$permission("82") &&
        !this.$permission("83") &&
        !this.$permission("57");

      const hideActionsTab2 = this.tabStatus == 2 && !this.$permission("84");

      const hideActionsTab3 = this.tabStatus == 3 && !this.$permission("84");

      const hideActionsTab4 =
        this.tabStatus == 4 &&
        !this.$permission("79") &&
        !this.$permission("78");

      return [
        { text: "Id", value: "id_event" },
        { text: this.$t("country"), value: "category_name" },
        { text: this.$t("event"), value: "description" },
        { text: this.$t("tournament"), value: "tournament_name" },
        { text: this.$t("dateTime"), value: "scheduled" },
        { text: this.$t("status"), value: "active", align: "center" },
        ...(hideActionsTab1 ||
        hideActionsTab2 ||
        hideActionsTab3 ||
        hideActionsTab4
          ? []
          : [
              {
                text: this.$t("actions"),
                value: "action",
                align: "center d-print-none",
              },
            ]),
      ];
    },
    tabs() {
      return {
        1: this.$t("actives"),
        2: this.$t("canceled"),
        3: this.$t("postponed"),
        4: this.$t("suspended"),
      };
    },
    eventStatus() {
      return this.$store.state.filters.selectStatusEvents.status;
    },
    canSuspendEventAndActivateEvent() {
      return this.$permission("78");
    },
    canCancelEventAndPostponeEvent() {
      return this.$permission("84");
    },
    canEditOdds() {
      return this.$permission("79");
    },
    canBetPlacedReport() {
      return this.$permission("82");
    },
    canAllMarketsReport() {
      return this.$permission("83");
    },
    canListMainEvents() {
      return this.$permission("57");
    },
    canAddMainEvent() {
      return this.$permission("58");
    },
    canRemoveMainEvent() {
      return this.$permission("59");
    },
  },

  watch: {
    "filter.active": function(val) {
      if (val == 1) {
        this.blocked = true;
      } else {
        this.filter.id_category = "";
        this.blocked = false;
      }
    },

    "filter.id_category": function(val) {
      if ((val == "" || val == undefined) && this.filter.active == 1) {
        this.blocked = true;
      } else {
        this.blocked = false;
      }
    },
  },

  async mounted() {
    this.$nextTick(() => {
      const ref = this.$vuetify.breakpoint.mobile
        ? "mobileBreakpoint"
        : "desktopBreakpoint";

      this.$refs[ref].$el.click();
    });

    this.canListMainEvents && this.fetchMainEvents();
    // this.mainEvents = JSON.parse(localStorage.getItem("mainEvents")) || [];
    const countries = await this.$request.get("colab/events/listCategories");
    this.countries = countries.dados;
    this.status = Object.values(this.tabs).map((item, index) => ({
      text: item,
      value: index + 1,
      color: this.colors[index + 1],
    }));
  },

  methods: {
    async doFilter() {
      const request = await this.$request.post(
        "colab/events/list",
        this.filter
      );

      if (!request.dados) {
        this.data = request;
        return;
      }

      // Tratamento do Resultado
      request.dados.forEach((item) => {
        // handler data
        item.scheduled = new Date(
          item.scheduled.replace(" ", "T")
        ).toLocaleString();
        // handler color
        const color = this.colorsColumns[item.active];
        // handler status
        item.active = {
          status: item.active,
          text: this.$legends.eventsActive(item.active),
          color,
        };
      });

      this.data = request.dados;
      this.tabStatus = this.filter.active;
    },

    // Cancelar/Adiar eventos
    async cancel(event) {
      try {
        this.loading = true;
        const status = ["4", "5", "6", "7"];
        const { id_event } = event;
        if (status.includes(event.active.status)) {
          const request = await this.$request.post(
            "/colab/events/cancelEventBets",
            { id_event }
          );
          this.setMsgFeedback(request.messages, "success");
          this.removeItemList(id_event);
        }
      } catch (error) {
        this.setMsgFeedback(this.$t("thisEventCannotBeCanceled"), "warning");
      } finally {
        this.loading = false;
      }
    },

    // Suspender Eventos
    async activeSuspendEvent(event, status) {
      const { id_event } = event;
      const request = await this.$request.post(
        "/colab/events/changeStatusEvent",
        { id_event, active: status }
      );

      if (request.messages) {
        this.setMsgFeedback(request.messages, "success");
        this.removeItemList(id_event);
      } else {
        this.setMsgFeedback(this.$t("thisEventCannotBeSuspended"), "warning");
      }
    },

    removeItemList(id_event) {
      this.data.filter((item, index) => {
        if (item.id_event == id_event) this.data.splice(index, 1);
      });
    },

    setMsgFeedback(msg, color) {
      this.$store.commit("setFeedbackSnack", { msg, color });
    },

    // Função chamada no change do select no mobile
    setStatusMobile(value) {
      this.filter.active = value;
    },

    showDialog(route) {
      this.$store.commit(`showDialog${route}`, true);
    },
    // showBetPlacedReportDialog() {
    //   this.$store.commit("setSelectEventStage", "prematch");
    //   this.$store.commit("showDialog", true);
    // },

    addOrRemoveMainEvent(event, isMainEvent) {
      this.mainEventLoading = true;

      if (isMainEvent) {
        this.$axios
          .post(
            "/colab/events/removeMainEvent",
            this.$formdata({ id_event: event.id_event })
          )
          .then((res) => {
            this.mainEvents = this.mainEvents.filter(
              ({ id_event }) => id_event !== event.id_event
            );

            this.$store.commit("setFeedbackSnack", {
              msg: res.data.messages,
              color: "success",
            });
          })
          .finally(() => {
            this.mainEventLoading = false;
          });
      } else {
        this.$axios
          .post(
            "/colab/events/addMainEvent",
            this.$formdata({
              id_event: event.id_event,
              id_sport: event.id_sport,
            })
          )
          .then((res) => {
            this.mainEvents = [...this.mainEvents, event];

            this.$store.commit("setFeedbackSnack", {
              msg: res.data.messages,
              color: "success",
            });
          })
          .finally(() => {
            this.mainEventLoading = false;
          });
      }
    },

    isMainEvent(event) {
      if (Array.isArray(this.mainEvents) && this.mainEvents.length > 0) {
        return this.mainEvents.find(
          ({ id_event }) => id_event === event.id_event
        );
      }

      return false;
    },

    getAddOrRemoveMainEventText(isMainEvent) {
      return isMainEvent ? this.$t("removeMainEvent") : this.$t("addMainEvent");
    },

    fetchMainEvents() {
      this.$axios
        .get("/colab/events/listMainEvents")
        .then((res) => {
          this.mainEvents = res.data.dados;
        })
        .catch(() => {
          this.mainEvents = [];
        });
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}
</style>
